type ParsedTime = {
  hours: number;
  minutes: number;
};

export function parseTime(time: string | null | undefined): ParsedTime | null {
  if (typeof time !== "string") {
    return null;
  }

  const trimmedTime = time.trim();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(trimmedTime);

  if (!match) {
    return null;
  }

  const hoursString = match[1];
  const minutesString = match[2];

  if (!hoursString || !minutesString) {
    return null;
  }

  return {
    hours: parseInt(hoursString, 10),
    minutes: parseInt(minutesString, 10),
  };
}

export function formatTimeToAmPm(
  time: string | null | undefined,
): string | null {
  const parsedTime = parseTime(time);

  if (!parsedTime) {
    return null;
  }

  const { hours, minutes } = parsedTime;
  const hour12 = hours % 12 || 12;
  const suffix = hours >= 12 ? "pm" : "am";

  return minutes === 0
    ? `${hour12}${suffix}`
    : `${hour12}:${minutes.toString().padStart(2, "0")}${suffix}`;
}
